module.exports = __webpack_public_path__ + "img/square-dollar.2e3cd50b.svg";